// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__1nGYA","buttonContainer":"style_buttonContainer__2bbSQ","error":"style_error__f2Mff"};